export enum TokenType {
    activation = 'activation',
    initialActivation = 'initialActivation',
    resetMfa = 'resetMfa',
    resetPassword = 'resetPassword',
    setHardwareToken = 'setHardwareToken',
}
